import React, { useState } from 'react'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import Table from 'react-bootstrap/Table'
import { Row, Col } from 'react-bootstrap'
import Search from 'shared/forms/search'
import { useDataAccesses } from 'api/hooks/use-data-accesses'
import { useNavigate } from 'react-router-dom'
import TableFooter from 'shared/tables/table-footer'
import TableLoading from 'shared/tables/table-loading'
import MunisModule from './MunisModule'


function DataAccesses() {
  const navigate = useNavigate()
  const defaultParams = {
    page: 1,
    perPage: 25,
    orderBy: 'name',
    orderDirection: 'asc',
    search: '',
    selectedModule: ''
  }
  const [params, setParams] = useState(defaultParams)
  const crumbs = [
    { name: 'Access Management', url: 'duties' },
    { name: 'Data Access', url: '' }
  ]

  const queryOptions = {
    keepPreviousData: true
  }

  const {
    isLoading,
    isSuccess,
    data: dataAccess
  } = useDataAccesses({ params, options: queryOptions })

  return (
    <Page title={'Data Access'}>
      <PageTitle breadcrumbs={crumbs} />

      <div className="my-4">
        <Row className="mb-4 mt-2">
          <Col sm={4}>
            <Search params={params} setParams={setParams} />
          </Col>
          <Col sm={4}>
            <MunisModule params={params} setParams={setParams} />
          </Col>
        </Row>
      </div>

      <div className="mt-2 mb-4">
        <Table
          hover
          responsive
          size="sm"
          className="border shadow-sm bg-white"
          style={{ border: '1px solid rgb(222 226 230)' }}
        >
          <thead>
            <tr>
              <th
                style={{
                  width: '25%'
                }}
              >
                Name
              </th>
              <th
                style={{
                  width: '15%'
                }}
              >
                Module
              </th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {isSuccess &&
              dataAccess.data.map((access) => (
                <tr
                  key={`row-${access.id}`}
                  onClick={() => navigate(`/data-access/${access.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <td>{access.name}</td>
                  <td>{access.top_module_name}</td>
                  <td className="text-muted">{access.description}</td>
                </tr>
              ))}
            {isLoading && <TableLoading columns={4} />}
          </tbody>
        </Table>
        {isSuccess && (
          <TableFooter
            meta={dataAccess.meta}
            params={params}
            setParams={setParams}
          />
        )}
      </div>
    </Page>
  )
}

export default DataAccesses
